import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { HttpClient } from './http-client.service';
import { CachedCallService } from './cached-call.service';

import { MemberUser } from '../../entities/member-user';
import { Club } from '../../entities/club';
import { OrgNode } from '../../entities/org-node';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class MemberUserService {

  private static readonly memberUserBaseUrl:string = `${Settings.apiUrl}/v1/MemberUsers`;
  private static readonly orgNodeBaseUrl:string = `${Settings.apiUrl}/v1/OrgNodes`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public currentUser:MemberUser = null;

  public currentUsersClub:Club = null;

  public currentUsersOrgHierarchy:OrgNode = null;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getMe():Promise<MemberUser>{
    return this.cachedCallService.invokeSingleCall(
            () => {
                return Promise.resolve().then(() => new MemberUser());
                // let memberUserUrl = MemberUserService.memberUserBaseUrl + "/RCC.Me/";

                // return this.http.get(memberUserUrl)
                //         .toPromise()
                //         .then(response => response.json().value)
                //         .then(memberUsers => {
                //           this.currentUser = memberUsers[0];
                //           return this.currentUser;
                //         });
            },
            "getMe"
        );
  }
  
  getMyClub():Promise<Club>{
    return this.cachedCallService.invokeSingleCall(
            () => {
                
                return Promise.resolve().then(() => new Club());
                // let myClub = MemberUserService.memberUserBaseUrl + "/RCC.MyClub/";

                // return this.http.get(myClub)
                //         .toPromise()
                //         .then(response => response.json().value)
                //         .then(clubs => {
                //           this.currentUsersClub = clubs[0];
                //           return this.currentUsersClub;
                //         });
            },
            "getMyClub"
        );
  }
  
  getMyOrgHierarchy():Promise<OrgNode>{
    let promise:Promise<any>;

    if(!this.currentUsersClub){
      promise = this.getMyClub();
    }else{
      promise = Promise.resolve().then(() => this.currentUsersClub);
    }

    return promise.then(
      getMyOrgHierarchy => 
        this.cachedCallService.invokeSingleCall(
            () => {
              let oDataBuilder:ODataBuilder = new ODataBuilder(MemberUserService.orgNodeBaseUrl);

              oDataBuilder.filter("OrgNodeId", ODataComparer.Equals, this.currentUsersClub.OrgNodeId)
                .expand("ParentOrgNode($expand=ParentOrgNode($expand=ParentOrgNode($expand=ParentOrgNode)))");

              return this.http.get(oDataBuilder.toString())
                      .toPromise()
                      .then(response => response.json().value)
                      .then(orgHierarchy => {
                        this.currentUsersOrgHierarchy = orgHierarchy[0];
                        return this.currentUsersOrgHierarchy;
                      });
            },
            "getMyOrgHierarchy"
        )
    );
  }
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/member-user.service.ts